import { useMutation, useQueryClient } from '@tanstack/react-query'
import { type ApiResponseError, fetchApiWithToken } from '~/api/utils'

export type BulkProcessAction = 'decline' | 'integrate' | 'integrate_accept'

type BulkProcessApplicationsPayload = {
  applicationIds: number[]
  action: BulkProcessAction
  applicantOrderStatus?: number
  note?: string
  sendEmail?: boolean
  templateId?: number
  emailSubject?: string
  emailContent?: string
}

type BulkProcessApplicationsResponse = {
  bulkId: string
  dispatchedCount: number
  skippedIds: number[]
}

export const useBulkProcessApplications = ({
  orderId
}: {
  orderId?: number
}) => {
  const queryClient = useQueryClient()

  return useMutation<
    BulkProcessApplicationsResponse,
    ApiResponseError,
    BulkProcessApplicationsPayload
  >({
    mutationFn: async (payload) =>
      await fetchApiWithToken<BulkProcessApplicationsResponse>({
        method: 'post',
        url: '/v1/applications/bulk-process',
        data: payload
      }),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['applications']
      })

      if (orderId) {
        queryClient.invalidateQueries({
          queryKey: ['order', orderId]
        })
      }

      queryClient.invalidateQueries({
        queryKey: ['orders']
      })
    }
  })
}
